import { render, staticRenderFns } from "./assign-trainer-course.vue?vue&type=template&id=280c73d3&scoped=true"
import script from "./assign-trainer-course.vue?vue&type=script&lang=js"
export * from "./assign-trainer-course.vue?vue&type=script&lang=js"
import style0 from "./assign-trainer-course.vue?vue&type=style&index=0&id=280c73d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c73d3",
  null
  
)

export default component.exports